import home from '@/pages/enViews/home/home.vue'
import company from '@/pages/enViews/companyInfos/company.vue'
import newsInfo from '@/pages/enViews/news/newsInfo.vue'
import news from '@/pages/enViews/news/news.vue'
import product from '@/pages/enViews/product/product.vue'
import productInfo from '@/pages/enViews/product/productInfo.vue'
import join from '@/pages/enViews/joinus/join.vue'
import bidding from '@/pages/enViews/bidding/bidding.vue'
import biddingInfo from '@/pages/enViews/bidding/biddingInfo.vue'
import privacy from '@/pages/enViews/privacy/privacy.vue'

/* eslint-disable */
const enFrontViews = [{
    path: '/iaic2019en/home',
    name: 'iaic2019en/home',
    component: home,
    meta: {
      title: 'IAIC'
    },
  },
  {
    path: '/iaic2019en/company',
    name: 'iaic2019en/company',
    component: company,
    meta: {
      title: 'IAIC'
    },
  },
  {
    path: '/iaic2019en/newsInfo/:newsId',
    name: 'iaic2019en/newsInfo',
    component: newsInfo,
    meta: {
      title: 'IAIC'
    },
  },
  {
    path: '/iaic2019en/news',
    name: 'iaic2019en/news',
    component: news,
    meta: {
      title: 'IAIC'
    },
  },
  {
    path: '/iaic2019en/product',
    name: 'iaic2019en/product',
    component: product,
    meta: {
      title: 'IAIC'
    },
  },
  {
    path: '/iaic2019en/join',
    name: 'iaic2019en/join',
    component: join,
    meta: {
      title: 'IAIC'
    },
  },
  {
    path: '/iaic2019en/privacy',
    name: 'iaic2019en/privacy',
    component: privacy,
    meta: {
      title: 'IAIC'
    },

  },
  {
    path: '/iaic2019en/bidding',
    name: 'iaic2019en/bidding',
    component: bidding,
    meta: {
      title: 'IAIC'
    },
  },
  {
    path: '/iaic2019en/biddingInfo/:bidId',
    name: 'iaic2019en/biddingInfo',
    component: biddingInfo,
    meta: {
      title: 'IAIC'
    },
  },
  {
    path: '/iaic2019en/productInfo/:productId',
    name: 'iaic2019en/productInfo',
    component: productInfo,
    meta: {
      title: 'IAIC'
    },
  }
];
export default [...enFrontViews]



// WEBPACK FOOTER //
// ./src/router/enViews.js